<div fxLayout="column" fxLayoutGap="20px">
  <section fxLayout fxLayoutGap="10px">
    <sbnb-icon-homeaway fxHide.lt-md [size]="26"></sbnb-icon-homeaway>
    <h2 *ngIf="mode !== 'update'" class="nomargin">Connecting {{ 'CORE.PRODUCT_NAME' | transloco }} with Vrbo</h2>
    <h2 *ngIf="mode === 'update'" class="nomargin">Update your Vrbo account connection</h2>
  </section>

  <section>
    <span>
      {{ 'CORE.PRODUCT_NAME' | transloco }} will request an authentication token, stored with state-of-the-art
      encryption. If you change your Vrbo password, or your Vrbo login method, our permissions to your account will be
      revoked.
    </span>
  </section>

  <section>
    <mat-form-field class="fw">
      <mat-label>Your Vrbo login</mat-label>

      <input matInput type="email" [(ngModel)]="username" />
    </mat-form-field>

    <mat-form-field class="fw">
      <mat-label>Your Vrbo password</mat-label>

      <input
        matInput
        type="password"
        (keyup.enter)="phaseComplete.emit({ username: username, password: password })"
        [(ngModel)]="password" />
    </mat-form-field>

    <div
      fxLayout
      fxLayoutGap="18px"
      fxLayoutAlign="end center"
      fxLayout.lt-md="column"
      fxLayoutAlign.lt-md="center stretch">
      <button
        id="connect-credentials-cancel"
        mat-flat-button
        [disabled]="loading"
        fxFlexOrder.lt-md="99"
        class="button__secondary"
        [routerLink]="['/accounts']">
        Cancel
      </button>
      <button
        id="connect-credentials-primary"
        mat-flat-button
        [disabled]="loading"
        (click)="phaseComplete.emit({ username: username, password: password })">
        {{ mode === 'update' ? 'Update' : 'Connect' }}
        <mat-spinner class="button__spinner" *ngIf="loading" diameter="30"></mat-spinner>
      </button>
    </div>
  </section>
</div>
